import * as React from 'react';
import { useState, useEffect } from 'react';
import Spinner from 'app/components/Spinner';

/* @jsxImportSource @emotion/react */  import { css, jsx } from '@emotion/react'; /* eslint-disable-line */

const style = css`
    position: absolute;
    top: 20%;
    bottom: 0;
    left: 0;
    right: 0;
	
    .message {
		text-align: center;
    }
`;

export default props => {

	const [message, setMessage] = useState('');

	useEffect(() => {
		const timeout = setTimeout(() => {
			if (setMessage) {
				setMessage('Authenticating...');
			}
		}, 2000);

		return () => clearTimeout(timeout);
	}, []);

	return (<div css={style}>
		<Spinner noCenter={true} />
		<div className="message">
			{message}
		</div>
	</div>);
};